import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { AlertCircle, CreditCard } from 'lucide-react';
import { Button } from './ui/button';

export const PaywallBanner = () => {
  const { isExpired, loading } = useSubscription();
  const navigate = useNavigate();

  if (loading || !isExpired) return null;

  return (
    <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" data-testid="paywall-banner">
      <div className="flex items-center gap-2">
        <AlertCircle className="h-4 w-4 text-red-400 flex-shrink-0" />
        <p className="text-sm text-red-300">
          Your subscription has expired. Subscribe to add trips, upload documents, and generate reports.
        </p>
      </div>
      <Button
        size="sm"
        onClick={() => navigate('/subscription')}
        className="bg-amber-600 hover:bg-amber-700 text-white whitespace-nowrap"
        data-testid="paywall-subscribe-btn"
      >
        <CreditCard className="h-3.5 w-3.5 mr-1.5" />
        Subscribe — £3.99/mo
      </Button>
    </div>
  );
};
